import { Injectable } from '@angular/core';

const messages = {
  'TOAST.successo': 'Operazione completata con successo',
  'TOAST.errore': 'Si è verificato un errore',
  'ERROR.utenza_bloccata':
    "La tua utenza è stata bloccata a causa del superamento del limite di errori nell'eseguire il login. Utilizza il modulo per recuperare la password per resettare le tue credenziali di accesso",
  'ERROR.utenza_non_trovata': 'Credenziali errate. Riprovare',
  'ERROR.utenza_sospesa':
    "La tua utenza è stata sospesa a causa di troppi tentativi di accesso con credenziali errate. Effettua il processo di recupero password per sbloccare l'utenza.",
  'ERROR.campo_obbligatorio': 'Campo obbligatorio',
  'ERROR.psw_corta': 'La password deve essere almeno di 8 caratteri',
  'ERROR.psw_non_coincidente': 'Le password non coincidono',
  'ERROR.campo_corto': 'Il campo prevede più caratteri',
  'ERROR.campo_troppo_lungo': 'Il valore inserito è troppo grande per il campo',
  'ERROR.email_valido': 'Inserire un indirizzo email valido',
  'ERROR.data_non_valida': 'La data inserita non è valida',
  'ERROR.campo_non_coincidente': 'Il campo non coincide',
  'ERROR.psw_regex': 'La password non rispetta i criteri di sicurezza indicati',
  'ERROR.data_futura': 'La data non può essere futura',
  'ERROR.data_futura_carico': 'La data di carico non può essere futura',
  NUM_MESI: [
    'Gennaio',
    'Febbraio',
    'Marzo',
    'Aprile',
    'Maggio',
    'Giugno',
    'Luglio',
    'Agosto',
    'Settembre',
    'Ottobre',
    'Novembre',
    'Dicembre'
  ]
} as const;

@Injectable({ providedIn: 'root' })
export class ItalianMessagesService {
  instant(key: keyof typeof messages): any {
    return messages[key] ?? key;
  }
}
